<template>
  <ExibicaoInputText
    v-model:text="text"
    :filtro="filtro"
    :campo="filtro"
    @excluded="excluirFiltro"
    @aplicarFiltro="aplicarFiltro"
    :path="path"
  />
</template>
<script>
import ExibicaoInputText from '../../components/ExibicaoInputText.vue';
import mixinFiltro from '../../mixins/mixinFiltro';
export default {
  emits: ['excluirFiltro'],
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    ExibicaoInputText
  },
  mixins: [mixinFiltro]
}
</script>
